<template>
    <div>
        <h4>Profil</h4>
        <div class="content-profil">
            <h5 class="title">Kelola Profil Anda</h5>
            <div class="wrap-full-content">
                <b-tabs content-class="mt-3">
                    <b-tab title="Data Pribadi" active>
                        <div class="text-right">
                            <button type="button" class="btn" @click="openPreview('Data Pribadi', 8)">Download</button>
                        </div>
                        <p class="sub-title">Identitas Pengguna</p>
                        <div class="form-group">
                            <label for="">Nama Lengkap</label>
                            <span>{{ dataPribadi.fullname }}</span>
                        </div>
                        <div class="form-group">
                            <label for="">Tempat/ tanggal lahir</label>
                            <span>{{ dataPribadi.place_of_birth }}, </span>
                            <span>{{ dataPribadi.date_of_birth | formatDate }}</span>
                        </div>
                        <div class="form-group">
                            <label for="">Alamat sesuai KTP</label>
                            <span>{{ dataPribadiIdentity.address }}</span>
                        </div>
                        <div class="form-group">
                            <label class="detail-alamat">Provinsi</label>
                            <span>{{ dataPribadiIdentity.province }}</span>
                        </div>
                        <div class="form-group">
                            <label class="detail-alamat">Kota</label>
                            <span>{{ dataPribadiIdentity.regency }}</span>
                        </div>
                        <div class="form-group">
                            <label class="detail-alamat">Kecamatan</label>
                            <span>{{ dataPribadiIdentity.district }}</span>
                        </div>
                        <div class="form-group">
                            <label class="detail-alamat">Kelurahan</label>
                            <span>{{ dataPribadiIdentity.village }}</span>
                        </div>
                        <div class="form-group">
                            <label class="detail-alamat">RT/RW </label>
                            <span>{{ dataPribadiIdentity.neighborhood_no }} / {{ dataPribadiIdentity.citizen_no }}</span>
                        </div>
                        <div class="form-group">
                            <label class="detail-alamat">Kodepos</label>
                            <span>{{ dataPribadiIdentity.postcode }}</span>
                        </div>
                        <div class="form-group">
                            <label for="">NPWP</label>
                            <span>{{ dataPribadi.npwp_no }}</span>
                        </div>
                        <div class="form-group">
                            <label for="">No Telepon Rumah</label>
                            <span>{{ dataPribadiIdentity.telephone }}</span>
                        </div>
                        <div class="form-group">
                            <label for="">Jenis Kelamin</label>
                            <span>{{ dataPribadi.gender_type.name }}</span>
                        </div>
                        <div class="form-group">
                            <label for="">No Identitas</label>
                            <span>( KTP ) {{ dataPribadi.ktp_no }}</span>
                        </div>
                        <div class="form-group">
                            <label for="">Setatus Perkawinan</label>
                            <span>{{ dataPribadi.marriage_type.name }}</span>
                        </div>
                        <div class="form-group">
                            <label for="">Nama suami/istri(Opsional)</label>
                            <span>{{ dataPribadi.partners_name ? dataPribadi.partners_name : "-" }}</span>
                        </div>
                        <div class="form-group">
                            <label for="">Nama ibu kandung</label>
                            <span>{{ dataPribadi.mothers_name }}</span>
                        </div>
                        <div class="form-group">
                            <label for="">Status Kepimilikan Rumah</label>
                            <span>{{ dataPribadiIdentity.ownership_status }}</span>
                        </div>
                        <div class="form-group">
                            <label for="">Tujuan pembukaan rekening</label>
                            <span>{{ dataPribadi.purpose_open_account_type.name }}</span>
                        </div>
                        <div class="form-group">
                            <label for="">Pengalaman Investasi</label>
                            <span>{{ dataPribadi.has_investment_experience ? "Pernah" : "Tidak" }}</span>
                        </div>

                        <div class="header-title" v-b-toggle.multiCollapseExample2>
                            <p class="sub-title">Data Pekerjaan <span class="arrow-down pull-right" /></p>
                        </div>
                        <b-collapse id="multiCollapseExample2">
                            <div class="form-group">
                                <label for="">Pekerjaan</label>
                                <span v-if="dataEmployment.occupation_type">
                                    {{ dataEmployment.occupation_type.code == 7 ? dataEmployment.other_occupation : dataEmployment.occupation_type.name }}
                                </span>
                            </div>
                            <div class="form-group">
                                <label for="">Nama perusahaan</label>
                                <span>{{ dataEmployment.company_name }}</span>
                            </div>
                            <div class="form-group">
                                <label for="">Bidang usaha</label>
                                <span>{{ dataEmployment.business_sector }}</span>
                            </div>
                            <div class="form-group">
                                <label for="">Jabatan</label>
                                <span>{{ dataEmployment.other_position }}</span>
                            </div>
                            <div class="form-group">
                                <label for="">Lama pekerjaan</label>
                            </div>
                            <div class="form-group">
                                <label class="detail-alamat">Saat ini</label>
                                <span>{{ dataEmployment.work_year }}</span>
                                <span class="tahun">Tahun</span>
                                <span>{{ dataEmployment.work_month }}</span>
                                <span class="tahun">Bulan</span>
                            </div>
                            <div class="form-group">
                                <label class="detail-alamat">Perusahaan sebelumnya</label>
                                <span>{{ dataEmployment.work_year_previous }}</span>
                                <span class="tahun">Tahun</span>
                            </div>
                            <div class="form-group">
                                <label for="">Alamat Perusahaan</label>
                                <span>{{ dataEmployment.company_address.address }}</span>
                            </div>
                            <div class="form-group">
                                <label class="detail-alamat">Provinsi</label>
                                <span>{{ dataEmployment.company_address.province }}</span>
                            </div>
                            <div class="form-group">
                                <label class="detail-alamat">Kota</label>
                                <span>{{ dataEmployment.company_address.regency }}</span>
                            </div>
                            <div class="form-group">
                                <label class="detail-alamat">Kecamatan</label>
                                <span>{{ dataEmployment.company_address.district }}</span>
                            </div>
                            <div class="form-group">
                                <label class="detail-alamat">Kelurahan</label>
                                <span>{{ dataEmployment.company_address.village }}</span>
                            </div>
                            <div class="form-group">
                                <label class="detail-alamat">RT/RW </label>
                                <span>{{ dataEmployment.company_address.neighborhood_no }} / {{ dataEmployment.company_address.citizen_no }}</span>
                            </div>
                            <div class="form-group">
                                <label>Kodepos</label>
                                <span>{{ dataEmployment.company_address.postcode }}</span>
                            </div>
                            <div class="form-group">
                                <label>No Telepon perusahaan</label>
                                <span>{{ dataEmployment.company_address.telephone }}</span>
                            </div>
                            <div class="form-group">
                                <label>No faksimail perusahaan(opsional)</label>
                                <span>{{ dataEmployment.company_address.fax }}</span>
                            </div>
                        </b-collapse>

                        <div v-b-toggle.dataKeuangan>
                            <p class="sub-title">
                                Data Keuangan dan transaksi
                                <span class="arrow-down pull-right" />
                            </p>
                        </div>
                        <b-collapse id="dataKeuangan">
                            <div class="form-group">
                                <label for="">Penghasilan pertahun</label>
                                <span>{{ dataFinancial.salary_type.name }}</span>
                            </div>
                            <div class="form-group">
                                <label for="">Lokasi rumah</label>
                                <span>{{ dataFinancial.wealth_list.home_location }}</span>
                            </div>
                            <div class="form-group">
                                <label for="">Nilai NJOP</label>
                                <span>{{ currencyFormat(dataFinancial.wealth_list.njop_value) }}</span>
                            </div>
                            <div class="form-group">
                                <label for="">Deposit Bank</label>
                                <span>{{ dataFinancial.wealth_list.deposit }}</span>
                            </div>
                            <div class="form-group">
                                <label for="">Jumlah</label>
                                <span>{{ currencyFormat(dataFinancial.wealth_list.total_deposit) }}</span>
                            </div>
                            <div class="form-group">
                                <label for="">Lainnya</label>
                                <span>{{ dataFinancial.wealth_list.other }}</span>
                            </div>
                        </b-collapse>

                        <div v-b-toggle.rekeningNasabah>
                            <p class="sub-title">Rekening Nasabah <span class="arrow-down pull-right" /></p>
                        </div>
                        <b-collapse id="rekeningNasabah">
                            <div>
                                <div class="form-group">
                                    <label>Nama bank</label>
                                    <span>{{ dataCustomer[0].name }}</span>
                                </div>
                                <div class="form-group">
                                    <label>No Rekening</label>
                                    <span>{{ dataCustomer[0].account_no }}</span>
                                </div>
                                <div class="form-group">
                                    <label>Cabang</label>
                                    <span>{{ dataCustomer[0].branch }}</span>
                                </div>
                                <div class="form-group">
                                    <label>Telepon</label>
                                    <span>{{ dataCustomer[0].phonenumber }}</span>
                                </div>
                                <div class="form-group">
                                    <label>Jenis Rekening</label>
                                    <span>{{ dataCustomer[0].type_account }}</span>
                                </div>
                            </div>
                        </b-collapse>

                        <div v-b-toggle.kontakDarurat>
                            <p class="sub-title">Kontak darurat <span class="arrow-down pull-right" /></p>
                        </div>
                        <b-collapse id="kontakDarurat">
                            <div class="form-group">
                                <label for="">Nama</label>
                                <span>{{ dataEmergency.fullname }}</span>
                            </div>
                            <div class="form-group">
                                <label for="">Alamat</label>
                                <span>{{ dataEmergency.address }}</span>
                            </div>
                            <div class="form-group">
                                <label>Kodepos</label>
                                <span>{{ dataEmergency.postcode }}</span>
                            </div>
                            <div class="form-group">
                                <label>No Telepon</label>
                                <span>{{ dataEmergency.phonenumber }}</span>
                            </div>
                            <div class="form-group">
                                <label for="">Hubungan anda</label>
                                <span>{{ dataEmergency.relationship }}</span>
                            </div>
                        </b-collapse>
                        <div v-b-toggle.lampiran>
                            <p class="sub-title">Lampiran <span class="arrow-down pull-right" /></p>
                        </div>
                        <b-collapse id="lampiran">
                            <div>
                                <b-card no-body>
                                    <b-tabs card fill>
                                        <b-tab no-body title="Rekening Bank">
                                            <b-card-img bottom :src="dataImags.rekBank" alt="Image 21"></b-card-img>
                                            <b-card-footer>Foto Rekening Koran Bank / Tagihan Kartu Kredit</b-card-footer>
                                        </b-tab>
                                        <b-tab no-body title="Rekening Listrik">
                                            <b-card-img bottom :src="dataImags.rekListrik" alt="Image 21"></b-card-img>
                                            <b-card-footer>Foto Rekening Listrik / Telepon</b-card-footer>
                                        </b-tab>
                                        <b-tab no-body title="KTP">
                                            <b-card-img bottom :src="dataImags.ktp" alt="Image 21"></b-card-img>
                                            <b-card-footer>Foto KTP</b-card-footer>
                                        </b-tab>
                                        <b-tab no-body title="NPWP">
                                            <b-card-img bottom :src="dataImags.npwp" alt="Image 21"></b-card-img>
                                            <b-card-footer>Foto NPWP</b-card-footer>
                                        </b-tab>
                                        <b-tab no-body title="Selfie">
                                            <b-card-img bottom :src="dataImags.photo" alt="Image 21"></b-card-img>
                                            <b-card-footer>Foto Terkini</b-card-footer>
                                        </b-tab>
                                        <b-tab no-body title="Diri & KTP">
                                            <b-card-img bottom :src="dataImags.photo_ktp" alt="Image 21"></b-card-img>
                                            <b-card-footer>Foto Diri dengan KTP</b-card-footer>
                                        </b-tab>
                                        <b-tab no-body title="Kartu Keluarga">
                                            <b-card-img bottom :src="dataImags.kk" alt="Image 21"></b-card-img>
                                            <b-card-footer>Foto Kartu Keluarga</b-card-footer>
                                        </b-tab>
                                        <b-tab no-body title="Tanda Tangan">
                                            <b-card-img bottom :src="dataImags.signature" alt="Image 21"></b-card-img>
                                            <b-card-footer>Foto Tanda Tangan</b-card-footer>
                                        </b-tab>
                                        <b-tab no-body title="Video">
                                            <video :src="dataImags.video_statement" controls></video>
                                            <h6>Video Verifikasi</h6>
                                            <!-- <b-card-img bottom src="https://picsum.photos/600/200/?image=21" alt="Image 21"></b-card-img>
                      <b-card-footer>Video Verifikasi</b-card-footer> -->
                                        </b-tab>
                                    </b-tabs>
                                </b-card>
                            </div>
                        </b-collapse>
                    </b-tab>
                    <b-tab title="Data Account">
                        <div class="d-flex justify-content-between">
                            <form @submit.prevent="changeProfil">
                                <div class="wrap-content">
                                    <div class="form-group">
                                        <label for="">Nama</label>
                                        <input type="text" v-model="dataProfil.fullname" readonly class="main-content" />
                                    </div>
                                    <div class="form-group">
                                        <label for="">Email</label>
                                        <input type="text" v-model="dataProfil.email" readonly class="main-content" />
                                    </div>
                                    <div class="form-group">
                                        <label for="">No Telepon</label>
                                        <input type="text" v-model="dataProfil.phonenumber" readonly class="main-content" />
                                    </div>
                                    <div class="form-group" @click="seleceted = 4" :class="{ active: seleceted == 4 }">
                                        <label for="">Password</label>
                                        <input type="password" v-model="password" value="form input" readonly class="main-content" placeholder="Ubah Password" />
                                    </div>
                                    <button class="btn-primer simpan" :class="{ contentActivebtn: seleceted == 5 }" type="submit">Simpan</button>
                                </div>
                            </form>
                            <div class="change-content">
                                <form>
                                    <div class="change-password" :class="{ contentActive: seleceted == 4 }">
                                        <div class="icon-action">
                                            <b-icon-arrow-left-short @click="seleceted = 0" />
                                            <span @click="seleceted = 0"><b-icon-x /></span>
                                        </div>
                                        <div class="form-group active">
                                            <label>Password</label>
                                        </div>

                                        <p>Ubah password anda</p>
                                        <p v-if="passwordKonfirmasi != rePasswordKonfirmasi" class="error">{{ message }}</p>
                                        <p v-if="alert == 401" class="error">Password lama salah</p>
                                        <input type="text" placeholder="masukkan password lama anda" class="form-input" v-model="$v.oldPassword.$model" />
                                        <div class="form-error" v-if="$v.oldPassword.$error">Password baru tidak bolah kosong</div>
                                        <input type="text" placeholder="masukkan password baru anda" class="form-input" v-model="$v.passwordKonfirmasi.$model" />
                                        <div class="form-error" v-if="$v.passwordKonfirmasi.$error">Password baru tidak bolah kosong</div>
                                        <input
                                            type="text"
                                            placeholder="masukkan masukkan ulang password baru anda baru anda"
                                            class="form-input"
                                            v-model="$v.rePasswordKonfirmasi.$model"
                                        />
                                        <div class="form-error" v-if="$v.rePasswordKonfirmasi.$error">Ulangi Password tidak bolah kosong</div>

                                        <div class="button">
                                            <div class="btn-div btn-scondary" @click="seleceted = 0">Batal</div>
                                            <div class="btn-div btn-primer" @click="changePassword">Ubah</div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab title="Document">
                        <div class="wrap-document">
                            <div class="document-item">
                                <div>PROFIL PERUSAHAAN PIALANG BERJANGKA</div>
                                <div>
                                    <button type="button" class="btn" @click="openPreview('Perusahaan Pialang Berjangka', 1)">Preview</button>
                                </div>
                            </div>
                            <div class="document-item">
                                <div>PERNYATAAN TELAH MELAKUKAN SIMULASI PERDAGANGAN BERJANGKA</div>
                                <div>
                                    <button type="button" class="btn" @click="openPreview('Simulasi Perdagangan Berjangka', 2)">Preview</button>
                                </div>
                            </div>
                            <div class="document-item">
                                <div>PERNYATAAN PENGUNGKAPAN (DISCLOSURE STATEMENT)</div>
                                <div>
                                    <button type="button" class="btn" @click="openPreview('Disclosure Statement', 3)">Preview</button>
                                </div>
                            </div>
                            <div class="document-item">
                                <div>DOKUMEN PEMBERITAHUAN ADANYA RISIKO</div>
                                <div>
                                    <button type="button" class="btn" @click="openPreview('Pemberitahuan Adanya Resiko', 4)">Preview</button>
                                </div>
                            </div>
                            <div class="document-item">
                                <div>PERJANJIAN PEMBERIAN AMANAT</div>
                                <div>
                                    <button type="button" class="btn" @click="openPreview('Pemberian Amanat', 5)">Preview</button>
                                </div>
                            </div>
                            <div class="document-item">
                                <div>PERATURAN PERDAGANGAN (TRADING RULES)</div>
                                <div>
                                    <button type="button" class="btn" @click="openPreview('Peraturan Perdagangan', 6)">Preview</button>
                                </div>
                            </div>
                            <div class="document-item">
                                <div>KODE AKSES TRANSAKSI NASABAH (Personal Access Password)</div>
                                <div>
                                    <button type="button" class="btn" @click="openPreview('Kode Akses', 7)">Preview</button>
                                </div>
                            </div>
                        </div>
                        <b-modal ref="modal-preview" :title="titlePreview" size="lg">
                            <b-button class="mt-3" variant="outline-info" @click="downloadPDF">
                                <b-spinner small v-if="isLoading" style="width: 20px; height: 20px"></b-spinner>
                                <span v-else>Download</span>
                            </b-button>

                            <profil-perusahaan
                                v-if="codePreview == 1"
                                :statementValue="print.has_set_company_profile"
                                :dataPrint="print"
                                ref="company"
                            ></profil-perusahaan>
                            <simulasi v-if="codePreview == 2" :dataPrint="print" :statementValue="print.has_set_trading_simulation" ref="simulation"></simulasi>
                            <disclosure-statement
                                v-if="codePreview == 3"
                                :disclosureValue="print.has_set_disclosure"
                                :dataPrint="print"
                                ref="disclosure"
                            ></disclosure-statement>
                            <resiko v-if="codePreview == 4" :dataPrint="print" :statementValue="print.has_set_risk" ref="risk"></resiko>
                            <amanah
                                v-if="codePreview == 5"
                                :dataPrint="print"
                                :statement="print.has_set_mandate"
                                :disputeValue="disputeValue"
                                ref="mandate"
                            ></amanah>
                            <div v-if="codePreview == 6">
                                <div v-for="(platform, i) in dataProfil.platform" :key="i">
                                    <trading-gofx id="metraTrader" ref="gofx" :dataPrint="print" v-show="platform.code == 'BEI05002'" />
                                    <trading-jfx v-show="platform.code == 'BEI05001'" id="javetnow" :dataPrint="print" />
                                </div>
                            </div>
                            <kode-akses v-if="codePreview == 7" :dataPrint="print" ref="access"></kode-akses>
                            <profil-user
                                v-if="codePreview == 8"
                                :dataPribadi="dataPribadi"
                                :dataEmergency="dataEmergency"
                                :dataWork="dataEmployment"
                                :dataFinance="dataFinancial"
                                :dataCustomer="dataCustomer"
                                :dataTradeAcount="dataTradAccount"
                                ref="selfData"
                            ></profil-user>
                        </b-modal>
                    </b-tab>
                </b-tabs>
            </div>
        </div>
        <!-- <div class="content-profil" ref="refElementPlatform">
            <p class="sub-title">Platform</p>
            <ul>
                <li v-for="(platform, i) in dataProfil.platform" :key="i">
                    {{ platform.name }}
                    <div>
                        <span>Username</span>
                        <span>:</span>
                        <span>{{ platform.demo_username }}</span>
                    </div>
                    <div>
                        <span>Password</span>
                        <span>:</span>
                        <span>{{ platform.demo_password }}</span>
                    </div>
                    <div>
                        <span>Trading Rules</span>
                        <span>:</span>
                        <span @click="showModal(platform.code)" class="btn btn-download">Buka</span>
                    </div>
                </li>
            </ul>
        </div> -->
        <b-modal ref="modal-rule" title="Trading Rule" size="lg">
            <b-button class="mt-3" variant="outline-info" @click="downloadTradingRule">
                <b-spinner small v-if="isLoading" style="width: 20px; height: 20px"></b-spinner>
                <span v-else>Download</span>
            </b-button>
            <trading-gofx id="metraTrader" ref="gofx" :dataPrint="print" v-show="platformCode == 'BEI05002'" />
            <trading-jfx v-show="platformCode == 'BEI05001'" id="javetnow" :dataPrint="print" />
        </b-modal>
    </div>
</template>

<script>
import html2canvas from "html2canvas";
import * as JsPDF from "jspdf";

import axios from "axios";

// import Amanah from '../assets/Amanah'
// import Simulasi from '../assets/Simulasi'

import { required, email } from "vuelidate/lib/validators";
import TradingGofx from "../assets/filedownload/TradingGofx.vue";
import TradingJfx from "../assets/filedownload/TradingJfx.vue";
import sha256 from "sha256";
import ProfilPerusahaan from "../assets/filedownload/ProfilPerusahaan.vue";
import Simulasi from "../assets/filedownload/Simulasi.vue";
import Amanah from "../assets/filedownload/Amanah.vue";
import Resiko from "../assets/filedownload/Resiko.vue";
import KodeAkses from "../assets/filedownload/KodeAkses.vue";
import DisclosureStatement from "../assets/filedownload/DisclosureStatement.vue";
import ProfilUser from "./component/ProfilUser.vue";

export default {
    components: {
        TradingGofx,
        TradingJfx,
        ProfilPerusahaan,
        Simulasi,
        Amanah,
        Resiko,
        KodeAkses,
        DisclosureStatement,
        ProfilUser,
    },
    data() {
        return {
            foto: require("@/assets/user.png"),
            email: "",
            telepone: "",
            password: "",
            tradingRuleGofx: false,
            platformCode: "",

            photo_profile: "",
            platformElement: "",

            seleceted: "",
            selectedDownload: "",
            imageData: require("@/assets/user.png"),
            oldPassword: "",
            emailKonfirmasi: "",
            teleponeKonfirmasi: "",
            passwordKonfirmasi: "",
            rePasswordKonfirmasi: "",
            isLoading: false,
            dataProfil: [],
            showComponen: false,
            dataPribadi: "",
            dataPribadiIdentity: "",
            dataPribadiDomicili: "",
            dataFinancial: "",
            dataEmployment: "",
            dataCustomer: "",
            dataEmergency: "",
            dataAttachment: "",
            dataTradAccount: "",
            disputeValue: "",

            message: "password baru dan ulangi password tidak sama",

            print: {
                full_name: "",
                broker_name: "",
                alamat: "",
                phone_number: "",
                identity_owner: "",
                job: "",
                tempat_ttd: "",
                ktp: "",
                pekerjaan: "",
                tandaTangan: null,
                noKantor: "",
                company_id: "",
                namaPejabat: "",
                jabatan: "",
                jabatanNasabah: "",
                no_ac_demo: "",
                complement: "",
                tanggalLahir: "",
                tempat_lahir: "",
                platform: [],
                has_set_trading_simulation: "",
                has_set_company_profile: "",
                has_set_investment_experience: "",
                has_set_mandate: "",
                has_set_risk: "",
                has_set_trading_rules: "",
                has_set_disclosure: "",
                tanggal_diterima: null,
                no_ac: "",
            },
            dataImags: {
                rekBank: "",
                rekListrik: "",
                ktp: "",
                photo: "",
                photo_ktp: "",
                signature: "",
                video_statement: "",
                kk: "",
                npwp: "",
            },
            alert: "",
            filePreview: "",
            titlePreview: "",
            codePreview: "",

            // print:'<Amanah/>'
        };
    },
    validations: {
        emailKonfirmasi: {
            required,
            email,
        },
        teleponeKonfirmasi: {
            required,
        },
        passwordKonfirmasi: {
            required,
        },
        rePasswordKonfirmasi: {
            required,
        },
        oldPassword: {
            required,
        },
    },
    mounted() {
        axios.get("/v2/user/profile").then((res) => {
            this.dataProfil = res.data.data.user;
            this.print.fullname = res.data.data.user.fullname;
            this.print.platform = res.data.data.user.platform;
        });

        this.$store.dispatch("getCustomer").then((res) => {
            this.disputeValue = res.problem_solving;
            this.print.broker_name = res.broker_agent;
            this.print.has_set_company_profile = res.has_set_company_profile;
            this.print.has_set_trading_simulation = res.has_set_trading_simulation;
            this.print.has_set_disclosure = res.disclosure_customer;
            this.print.has_set_risk = res.has_set_risk;
            this.print.has_set_company_profile = res.has_set_company_profile;
            this.print.has_set_company_profile = res.has_set_company_profile;
            this.print.alamat =
                res.identity_address.address +
                ", Kel." +
                res.identity_address.village +
                ", Kec." +
                res.identity_address.district +
                ", " +
                res.identity_address.regency +
                ", " +
                res.identity_address.province +
                ", " +
                res.identity_address.postcode;
            this.print.tempat_lahir = res.place_of_birth;
            this.print.tanggalLahir = res.date_of_birth;
            this.print.ktp = res.identity_type + " - " + res.ktp_no;
            this.print.statement = res.has_set_trading_simulation;
            this.print.tempat_ttd = res.identity_address.regency;
            this.dataPribadi = res;
            this.dataPribadiIdentity = res.identity_address;
            this.dataPribadiDomicili = res.domicile_address;
            this.print.tanggal_diterima = res.created_at;

            axios.get("/v2/kyc/financial/" + res._id).then((resfin) => {
                this.dataFinancial = resfin.data.data.financial;
            });
            axios.get("/v2/kyc/employment/" + res._id).then((resemp) => {
                this.dataEmployment = resemp.data.data.employment;
                this.print.pekerjaan = this.dataEmployment.occupation_type.name;
                this.print.jabatanNasabah = this.dataEmployment.position_type.name;
                this.print.noKantor = this.dataEmployment.company_address.telephone;
            });
            axios.get("/v2/kyc/trade-account/" + res._id).then((resTrade) => {
                let datatrade = resTrade.data.data.trade_account.data;
                this.dataTradAccount = datatrade;
                for (let i = 0; i < datatrade.length; i++) {
                    this.print.no_ac = datatrade[i].username;
                }
            });
            axios.get("/v2/kyc/bank/account/" + res._id).then((resacc) => {
                this.dataCustomer = resacc.data.data.customer.bank_account;
            });
            axios.get("/v2/kyc/emergency_contact/" + res._id).then((reseme) => {
                this.dataEmergency = reseme.data.data.emergency_contact;
            });
            axios.get("/v2/kyc/attachment/" + res._id).then((resatch) => {
                this.dataAttachment = resatch.data.data.attachment;
                this.$store.dispatch("getImageAccess", this.dataAttachment.bank_statement).then((res) => {
                    this.dataImags.rekBank = res;
                });
                this.$store.dispatch("getImageAccess", this.dataAttachment.other).then((res) => {
                    this.dataImags.rekListrik = res;
                });
                this.$store.dispatch("getImageAccess", this.dataAttachment.ktp).then((res) => {
                    this.dataImags.ktp = res;
                });
                this.$store.dispatch("getImageAccess", this.dataAttachment.photo).then((res) => {
                    this.dataImags.photo = res;
                });
                this.$store.dispatch("getImageAccess", this.dataAttachment.photo_with_ktp).then((res) => {
                    this.dataImags.photo_ktp = res;
                });
                this.$store.dispatch("getImageAccess", this.dataAttachment.signature).then((res) => {
                    this.dataImags.signature = res;
                    this.print.tandaTangan = res;
                });
                this.$store.dispatch("getImageAccess", this.dataAttachment.statement_video).then((res) => {
                    this.dataImags.video_statement = res;
                });
                this.$store.dispatch("getImageAccess", this.dataAttachment.kk).then((res) => {
                    this.dataImags.kk = res;
                });
                this.$store.dispatch("getImageAccess", this.dataAttachment.npwp).then((res) => {
                    this.dataImags.npwp = res;
                });
            });
        });
    },
    methods: {
        openPreview(title, code) {
            this.$refs["modal-preview"].show();
            this.titlePreview = title;
            this.codePreview = code;
        },
        currencyFormat(value) {
            return (value + "").replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },
        showModal(code) {
            this.platformCode = code;
            this.$refs["modal-rule"].show();
        },
        changeFoto(event) {
            const foto = event.target;
            this.photo_profile = foto.files[0];
            // this.foto = foto.files[0]
            if (foto.files && foto.files[0]) {
                let reader = new FileReader();
                reader.onload = (event) => {
                    this.imageData = event.target.result;
                };
                reader.readAsDataURL(foto.files[0]);
            }
        },

        safeFoto() {
            this.foto = this.imageData;
            this.seleceted = 0;
            location.reload(false);
        },

        changeEmail() {
            this.$v.emailKonfirmasi.$touch();
            if (this.$v.emailKonfirmasi.$error) {
                return;
            } else {
                this.email = this.emailKonfirmasi;
                this.seleceted = 0;
            }
        },

        changeTelphone() {
            this.$v.teleponeKonfirmasi.$touch();
            if (this.$v.teleponeKonfirmasi.$error) {
                return;
            } else {
                this.telepone = this.teleponeKonfirmasi;
                this.seleceted = 0;
            }
        },

        changeProfil() {
            let data = {
                email: this.email,
                phone_number: this.telepone,
            };

            let formData = new FormData();
            formData.append("photo_profile", this.photo_profile);
            this.$store.dispatch("ubahProfil", data);
            let dataResponse = this.$store.state.message;
            if (dataResponse == 200) {
                this.$notify({
                    group: "profil",
                    title: "<h5>Berhasil</h5>",
                    type: "success",
                });
            }
            // })
        },
        changePassword() {
            // passwordKonfirmasi == rePasswordKonfirmasi ? password = passwordKonfirmasi : message, seleceted = 5
            this.$v.passwordKonfirmasi.$touch();
            this.$v.rePasswordKonfirmasi.$touch();
            this.$v.oldPassword.$touch();
            if (this.$v.passwordKonfirmasi.$error && this.$v.rePasswordKonfirmasi.$error && this.$v.oldPassword.$error) {
                return;
            } else {
                if (this.passwordKonfirmasi == this.rePasswordKonfirmasi) {
                    let data = {
                        new_password: sha256(this.passwordKonfirmasi),
                        password: sha256(this.oldPassword),
                    };
                    axios
                        .put("/v2/user/password", data)
                        .then((res) => {
                            if (res.data.data.status_code == "00") {
                                this.$toast.success("Password berhasil diubah");
                                this.seleceted = 5;
                                this.password = this.passwordKonfirmasi;
                            } else if (res.data.data.status_code) {
                                this.$toast.error("Password salah");
                            }
                        })
                        .catch((error) => {
                            let status = error.response.status;
                            this.alert = status;
                        });
                } else {
                    return this.message;
                }
            }
        },

        isNumber(event) {
            const pattern = /[0-9]/;

            let inputChar = String.fromCharCode(event.charCode);
            if (event.keyCode != 8 && !pattern.test(inputChar)) {
                event.preventDefault();
            }
        },

        downloadAmanah() {
            let url = window.open("http://localhost:8083/amanah");
            url.print();
            // url.close()
            // window.close()
        },

        downloadTradingRule() {
            this.isLoading = true;
            var data;
            var name = "";
            if (this.codePreview == 1) {
                name = "Profil_Perusahaan.pdf";
                data = this.$refs.company.$el;
            } else if (this.codePreview == 2) {
                name = "Simulasi.pdf";
                data = this.$refs.simulation.$el;
            } else if (this.codePreview == 3) {
                name = "Disclosure.pdf";
                data = this.$refs.disclosure.$el;
            } else if (this.codePreview == 4) {
                name = "Resiko.pdf";
                data = this.$refs.risk.$el;
            } else if (this.codePreview == 5) {
                name = "Amanah.pdf";
                data = this.$refs.mandate.$el;
            } else if (this.codePreview == 6) {
                if (this.dataProfil.platform[0].code == "BEI05002") {
                    name = "TradingRules_MetaTrader5.pdf";
                    data = this.$refs.gofx.$el;
                } else {
                    name = "TradingRules_JafetsNow.pdf";
                    data = document.getElementById("javetnow");
                }
            } else if (this.codePreview == 7) {
                name = "KodeAkses.pdf";
                data = this.$refs.access.$el;
            } else if (this.codePreview == 8) {
                name = "Data_Pribadi";
                data = this.$refs.selfData.$el;
            }
            console.log(data, name);

            // html2canvas(data, { useCORS: true, scale: 2 }).then((canvas) => {
            //     var margin = 10;
            //     var imgWidth = 210 - 2 * margin;
            //     var pageHeight = 297;
            //     var imgHeight = (canvas.height * imgWidth) / canvas.width + 90;
            //     console.log(imgHeight);
            //     var heightLeft = imgHeight;
            //     let img = canvas.toDataURL("image/png");
            //     let pdf = new JsPDF("p", "mm");
            //     var position = 0;
            //     pdf.addImage(img, "PNG", margin, position, imgWidth, imgHeight, "", "FAST");
            //     heightLeft -= pageHeight;
            //     while (heightLeft >= 0) {
            //         position = heightLeft - imgHeight;
            //         pdf.addPage();
            //         pdf.addImage(img, "PNG", margin, position, imgWidth, imgHeight, "", "FAST");
            //         heightLeft -= pageHeight;
            //     }
            //     this.tradingRuleGofx = false;
            //     pdf.save(name);
            //     this.isLoading = false;
            // });
        },
        downloadPDF() {
            this.isLoading = true;
            var data;
            var name = "";
            if (this.codePreview == 1) {
                name = "Profil_Perusahaan.pdf";
                data = this.$refs.company.$el;
            } else if (this.codePreview == 2) {
                name = "Simulasi.pdf";
                data = this.$refs.simulation.$el;
            } else if (this.codePreview == 3) {
                name = "Disclosure.pdf";
                data = this.$refs.disclosure.$el;
            } else if (this.codePreview == 4) {
                name = "Resiko.pdf";
                data = this.$refs.risk.$el;
            } else if (this.codePreview == 5) {
                name = "Amanah.pdf";
                data = this.$refs.mandate.$el;
            } else if (this.codePreview == 6) {
                if (this.dataProfil.platform[0].code == "BEI05002") {
                    name = "TradingRules_MetaTrader5.pdf";
                    data = document.getElementById("metraTrader");
                } else {
                    name = "TradingRules_JafetsNow.pdf";
                    data = document.getElementById("javetnow");
                }
            } else if (this.codePreview == 7) {
                name = "KodeAkses.pdf";
                data = this.$refs.access.$el;
            } else if (this.codePreview == 8) {
                name = "Data_Pribadi";
                data = this.$refs.selfData.$el;
            }

            html2canvas(data, { useCORS: true, scale: 3, allowTaint: true, scrollY: 0 }).then((canvas) => {
                const image = { type: "jpeg", quality: 0.98 };
                const margin = [10, 10];
                var imgWidth = 210;
                var pageHeight = 297;

                var innerPageWidth = imgWidth - margin[0] * 2;
                var innerPageHeight = pageHeight - margin[1] * 2;

                var pxFullHeight = canvas.height;
                var pxPageHeight = Math.floor(canvas.width * (pageHeight / imgWidth));
                var nPages = Math.ceil(pxFullHeight / pxPageHeight);

                pageHeight = innerPageHeight;

                var pageCanvas = document.createElement("canvas");
                var pageCtx = pageCanvas.getContext("2d");
                pageCanvas.width = canvas.width;
                pageCanvas.height = pxPageHeight;

                var pdf = new JsPDF("p", "mm", "a4");
                for (var page = 0; page < nPages; page++) {
                    if (page === nPages && pxFullHeight % pxPageHeight !== 0) {
                        pageCanvas.height = pxFullHeight % pxPageHeight;
                        pageHeight = (pageCanvas.height * innerPageWidth) / pageCanvas.width;
                    }

                    var w = pageCanvas.width;
                    var h = pageCanvas.height;
                    pageCtx.fillStyle = "white";
                    pageCtx.fillRect(0, 0, w, h);
                    pageCtx.drawImage(canvas, 0, page * pxPageHeight, w, h, 0, 0, w, h);
                    if (page >= 0) pdf.addPage();
                    debugger;
                    var imgData = pageCanvas.toDataURL("image/png");
                    pdf.addImage(imgData, image.type, margin[1], margin[0], innerPageWidth, pageHeight);
                }

                this.tradingRuleGofx = false;
                pdf.save(name);
                this.isLoading = false;
            });
        },
        async generatePdf() {
            var data;
            var name = "";
            if (this.codePreview == 1) {
                name = "Profil_Perusahaan.pdf";
                data = this.$refs.company.$el;
            } else if (this.codePreview == 2) {
                name = "Simulasi.pdf";
                data = this.$refs.simulation.$el;
            } else if (this.codePreview == 3) {
                name = "Disclosure.pdf";
                data = this.$refs.disclosure.$el;
            } else if (this.codePreview == 4) {
                name = "Resiko.pdf";
                data = this.$refs.risk.$el;
            } else if (this.codePreview == 5) {
                name = "Amanah.pdf";
                data = this.$refs.mandate.$el;
            } else if (this.codePreview == 6) {
                if (this.platformCode == "BEI05002") {
                    name = "TradingRules_MetaTrader5.pdf";
                    data = this.$refs.gofx.$el;
                } else {
                    name = "TradingRules_JafetsNow.pdf";
                    data = document.getElementById("javetnow");
                }
            } else if (this.codePreview == 7) {
                name = "KodeAkses.pdf";
                data = this.$refs.access.$el;
            } else if (this.codePreview == 8) {
                name = "Data_Pribadi";
                data = this.$refs.selfData.$el;
            }
            window.html2canvas = html2canvas;
            let docPdf = new JsPDF("p", "pt");
            let height = docPdf.internal.pageSize.height;
            let width = docPdf.internal.pageSize.width;
            const opt = {
                callback(docPdf) {
                    docPdf.save(name);
                },
                margin: [100, 100, 100, 100],
                width: width,
                height: height,
                autoPaging: "text",
                html2canvas: {
                    allowTaint: true,
                    dpi: 300,
                    letterRendering: true,
                    logging: false,
                },
            };
            docPdf.html(data, opt);
        },
    },

    // computed:{
    //     response(){

    //     },

    // }
};
</script>

<style scoped>
.content-profil {
    font-size: 14px;
    background-color: #fff;
    border-radius: 1rem;
    box-shadow: 0 0 2rem 0 rgb(136 152 170 / 13%);
    margin-top: 3rem;
    padding: 2rem;
}
.dropdown-item {
    font-size: 14px;
}

.wrap-download {
    border: solid 1px #dddddd;
    padding: 5px 20px;
    border-radius: 10px;
    background-color: #6454f0;
    color: white;
    cursor: pointer;
}

.wrap-title {
    display: flex;
    justify-content: space-between;
}

.icon-download {
    font-size: 23px;
    margin-right: 6px;
}

.download {
    border: solid 1px #dddddd;
    padding: 7px;
    height: 40px;
    width: 132px;
    text-align: center;
    border-radius: 10px;
    cursor: pointer;
    font-size: 14px;
    line-height: 1.7;
}

.download:hover {
    background: #6454f0;
    color: #ffffff;
}

.text-download {
    cursor: pointer;
    /* font-size: 12px; */
}

.text-download:hover {
    color: #6454f0;
}

.document-item {
    display: flex;
    justify-content: space-between;
}
.btn-div {
    text-align: center;
    line-height: 3;
}

.img-store {
    position: absolute;
    top: 0;
    right: 0px;
}

.img-store img {
    width: 30px;
    border-radius: 50%;
}

video {
    width: 100%;
}

.wrap-content {
    width: 470px;
    /* height: 302px; */
    border-radius: 10px;
    border: solid 1px #b3b3b3;
    background-color: #ffffff;
    padding: 40px 35px;
}

.change-foto,
.change-email,
.change-telepon,
.change-password {
    position: relative;
    width: 470px;
    border-radius: 10px;
    border: solid 1px #b3b3b3;
    background-color: #ffffff;
    padding: 50px 35px;
    display: none;
}

.icon-action {
    width: 92%;
    position: absolute;
    top: 4px;
    display: flex;
    justify-content: space-between;
    font-size: 40px;
    left: 19px;
    cursor: pointer;
}

.icon-action span {
    font-size: 35px;
}

.form-group {
    display: flex;
    gap: 1.5rem;
}

.form-group label {
    width: 11rem;
    color: #707070;
    font-size: 14px;
}

.detail-alamat {
    margin-inline-start: 1.5rem;
    width: 9.5rem !important;
}

.form-group span {
    font-weight: 800;
    font-size: 15px;
}

.form-group .main-content {
    border: none;
    font-size: 14px;
    cursor: pointer;
    width: 64%;
    color: #707070;
}

.form-group input:focus {
    outline: none;
}

.form-input {
    width: 100%;
    height: 50px;
    border-radius: 15px;
    border: solid 1px #707070;
    margin-bottom: 10px;
}

.title {
    font-size: 25px;
    font-weight: bold;
    /* margin: 0 0 50px 0; */
}

.sub-title {
    font-size: 18px;
    cursor: pointer;
}

.img {
    width: 210px;
    margin: 30px auto;
}

.img img {
    width: 210px;
    border-radius: 50%;
}

.button {
    display: flex;
    justify-content: space-between;
    margin-top: 60px;
}

.active {
    border-bottom: solid 1px #6454f0;
}

.contentActive {
    display: block;
    /* margin-top: 50px; */
}

.contentActivebtn {
    display: block;
    margin-top: 50px;
}

.form-error {
    font-size: 12px;
    margin-left: 5px;
    margin-bottom: 10px;
    color: #e74c3c;
}

ul {
    list-style: none;
}

ul li div {
    padding: 0 1rem;
    font-size: 15px;
    display: flex;
    align-items: center;
    gap: 1rem;
}

ul li div span:first-child {
    width: 6rem;
}

.arrow-down {
    border: solid #1f354a;
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 4px;
    transform: rotate(45deg);
}

.btn-download {
    cursor: pointer;
    padding: 0.5rem;
}

.btn-download:hover {
    box-shadow: 0 7px 14px rgb(50 50 93 / 10%), 0 3px 6px rgb(0 0 0 / 8%);
}

ul li .icon {
    font-size: 1.5rem;
}

@media (max-width: 768px) {
    .wrap-content {
        padding: 1rem 0;
        width: 100%;
        border: unset;
    }

    .content-profil {
        padding: 1rem;
    }

    .form-group {
        gap: 0.5rem;
    }

    .contentActive {
        display: block;
        position: absolute;
        top: 6rem;
        right: 1rem;
        width: 90%;
    }

    .button {
        flex-direction: column;
        align-items: center;
        gap: 0.5rem;
    }

    .btn-div {
        width: 100%;
    }
}
</style>
